'use strict';

var _ = require('lodash');
var GridToolbarConfigurationEntityController = function GridToolbarConfigurationEntityController($scope) {
  $scope.selectedRows = [];
  $scope.gridCellValueChanged = false;
  $scope.onRowSelection = function (selectedRows) {
    $scope.selectedRows = selectedRows;
  };
  $scope.onCellDoubleClick = function (args) {
    var rowIndex = args.rowindex;
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    var datafield = args.datafield;
    var rowid = $scope.jqxGridSettings.jqxGrid('getrowid', rowIndex);
    var row = loadedData[rowid];
    if (row.isNewlyAdded) {
      $scope.jqxGridSettings.jqxGrid('setcolumnproperty', datafield, 'editable', true);
    } else {
      $scope.jqxGridSettings.jqxGrid('setcolumnproperty', datafield, 'editable', false);
    }
  };
  function setStructureWithOldValues(loadedData, rowid) {
    loadedData[rowid]._old = {};
    var columns = $scope.jqxGridSettings.columns;
    _.forEach(columns, function (col) {
      loadedData[rowid]._old[col.datafield] = undefined;
    });
  }
  $scope.addEntity = function () {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    loadedData.unshift({
      isNewlyAdded: true
    });
    setStructureWithOldValues(loadedData, 0);
    $scope.updateData(loadedData);
  };
  $scope.saveChanges = function () {
    var rows = _.chain($scope.jqxGridSettings.source.loadedData).clone(true).map(function (row) {
      delete row.isNewlyAdded;
      delete row.originalRowId;
      return row;
    }).value(true);
    $scope.$emit('configuration-entity:saveChanges', rows);
  };
};
GridToolbarConfigurationEntityController.$inject = ['$scope'];
module.exports = GridToolbarConfigurationEntityController;